import script from "./MessageView.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageView.vue?vue&type=script&setup=true&lang=js"

import "./MessageView.vue?vue&type=style&index=0&id=2d4ff111&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4ff111"]])

export default __exports__